import { Component, inject, OnInit } from '@angular/core';
import { NavComponent } from './client/nav/nav.component';
import { RouterOutlet } from '@angular/router';
import { NavService } from '../nav/service/nav.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'admin-client',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [NavComponent, RouterOutlet],
  providers: [ConfirmationService],
})
export class AdminComponent implements OnInit {
  navService = inject(NavService);

  ngOnInit(): void {
    this.navService.setGreenBackground();
  }
}
